module.exports = __webpack_public_path__ + "img/icons8-download-from-cloud.dbe908c9.gif";